/* eslint-disable react/prop-types */
import { Trans, useTranslation } from 'react-i18next'
import { CheckIconModal } from '../CheckIconModal'

function DefaultDescription() {
  return (
    <Trans
      i18nKey="upsell.modals.payment_success_default"
      components={{ 1: <br /> }}
    />
  )
}

export const PaymentSuccessModal = ({
  isOpen,
  onClose,
  title,
  description,
  primaryAction,
  secondaryAction,
  showCloseButton = true,
  showCheckIcon = true,
}) => {
  const { t } = useTranslation()

  return (
    <CheckIconModal
      isOpen={isOpen}
      onClose={onClose}
      title={title ?? t('upsell.modals.payment_success_title')}
      titleId="payment-success-modal-title"
      description={description ?? <DefaultDescription />}
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      showCloseButton={showCloseButton}
      showCheckIcon={showCheckIcon}
    />
  )
}

export default PaymentSuccessModal
